import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// LOCALE
import { t } from '@/locale/i18n';

// CONSTANTS
import * as endpoints from '@/constants/api';

// UTILITY
import { getLink } from '@/utility/routes';
import { pushSuccessNotification } from '@/utility/snackbar';
import { showErrorNotification } from '@/utility/saga';

// STORE
import { UsersActions } from '@/store/actions';

const { getUsers, addUser, updateUser, activateUser } = UsersActions;

export function* getUsersSaga(action) {
  yield put({ type: getUsers.types.START });

  const { params } = action.payload;

  try {
    const { data: respData } = yield axios.get(endpoints.USERS_GET_LIST, { params });

    yield put({
      type: getUsers.types.SUCCESS,
      payload: {
        data: respData.data,
        meta: respData.meta,
      },
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getUsers.types.FAIL,
    });
  }
}

export function* addUserSaga(action) {
  yield put({ type: addUser.types.START });

  const { data, callback } = action.payload;

  try {
    yield axios.post(endpoints.USERS_ADD_USER, data);

    yield put({
      type: addUser.types.SUCCESS,
    });

    pushSuccessNotification(t('notification.inviteSentSuccess'));

    if (callback?.call) callback();
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: addUser.types.FAIL,
    });
  }
}

export function* updateUserSaga(action) {
  const { user_id, data, callback } = action.payload;
  const url = getLink(endpoints.USERS_UPDATE_USER, { user_id });

  yield put({ type: updateUser.types.START, payload: { user_id, data } });

  try {
    const requestData = { role: data.role };

    if (data.partner_id !== undefined) {
      requestData.partner_id = data.partner_id;
    }

    yield axios.post(url, requestData);

    yield put({
      type: updateUser.types.SUCCESS,
      payload: { user_id, data },
    });

    pushSuccessNotification(t('notification.updateUserSuccess'));

    if (callback?.call) callback();
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: updateUser.types.FAIL,
      payload: { user_id },
    });
  }
}

export function* activateUserSaga(action) {
  const { user_id, data, callback } = action.payload;

  yield put({ type: activateUser.types.START, payload: { user_id } });

  const url = getLink(endpoints.USERS_ACTIVATE_USER, { user_id });

  try {
    yield axios.post(url, data);

    yield put({
      type: activateUser.types.SUCCESS,
      payload: { user_id, active: data.active },
    });

    pushSuccessNotification(
      t(`notification.${data.active ? 'activateUserSuccess' : 'deactivateUserSuccess'}`),
    );

    if (callback?.call) callback();
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: activateUser.types.FAIL,
      payload: { user_id },
    });
  }
}

export default getUsersSaga;
